import { useEffect, useState } from 'react';
import Reveal from '../../components/Reveal';
import HeroSlideshow from '../../components/HeroSlideshow';
import SafeImage from '../../components/SafeImage';
import './meru.css';
import { IMAGE_FALLBACK, MERU_HERO_SLIDES, MERU_PAGE_IMAGES } from '../../data/destinationImages';

const MERU_IMAGES = MERU_PAGE_IMAGES;

const HERO_STATS = [
  { value: '4,566 m', label: 'Socialist Peak', delay: 0 },
  { value: '3–4', label: 'Days to summit', delay: 80 },
  { value: '#2', label: 'Highest in Tanzania', delay: 160 },
  { value: 'Arusha NP', label: 'National Park', delay: 240 },
];

const HIGHLIGHTS = [
  {
    iconImage: MERU_IMAGES.summit,
    title: 'Socialist Peak',
    text: 'Reach Tanzania\'s second-highest point at 4,566 metres a rewarding summit with sweeping views across northern Tanzania.',
    facePosition: 'center 35%',
  },
  {
    iconImage: MERU_IMAGES.crater,
    title: 'Meru Crater',
    text: 'Trek along the rim of a dramatic volcanic caldera ash cones, sheer cliffs, and one of East Africa\'s most striking mountain landscapes.',
    facePosition: 'center 40%',
  },
  {
    iconImage: MERU_IMAGES.mountain,
    title: 'Kilimanjaro Views',
    text: 'From the summit ridge, Kilimanjaro floats above the clouds a unforgettable panorama and the perfect Kili acclimatisation trek.',
    facePosition: 'center 38%',
  },
  {
    iconImage: MERU_IMAGES.wildlife,
    title: 'Wildlife on the Slopes',
    text: 'Arusha National Park surrounds the mountain giraffes, buffalo, and colobus monkeys often seen on the lower forest trails.',
    facePosition: 'center 42%',
  },
  {
    iconImage: MERU_IMAGES.huts,
    title: 'Mountain Huts',
    text: 'Overnight at Miriakamba and Saddle huts sheltered stops that break the climb into manageable stages through varied terrain.',
    facePosition: 'center 45%',
  },
  {
    iconImage: MERU_IMAGES.forest,
    title: 'Montane Forest',
    text: 'The Momella route begins in lush cloud forest mossy trails, birdlife, and the scent of juniper and wildflowers on the way up.',
    facePosition: 'center 30%',
  },
];

const SEASONS = [
  {
    badge: 'peak',
    title: 'Dry Season I',
    months: 'January – March',
    text: 'Clear mornings and stable conditions excellent visibility of Kilimanjaro from the Meru summit ridge.',
  },
  {
    badge: 'peak',
    title: 'Dry Season II',
    months: 'June – October',
    text: 'Cool, dry trekking weather and the most popular window ideal before a Kilimanjaro climb in the same trip.',
  },
  {
    badge: 'shoulder',
    title: 'Shoulder Season',
    months: 'November & May',
    text: 'Fewer trekkers on the Momella route and softer light for photography pack for occasional afternoon showers.',
  },
];

const EXPERIENCES = [
  {
    image: MERU_IMAGES.route,
    title: 'Momella Route Trek',
    text: 'The classic four-day ascent through forest, moorland, and crater rim to Socialist Peak Tanzania\'s premier warm-up climb.',
  },
  {
    image: MERU_IMAGES.mountain,
    title: 'Meru + Kilimanjaro Combo',
    text: 'Climb Meru first for altitude acclimatisation, then transfer to Kilimanjaro the smartest two-summit itinerary in the north.',
  },
  {
    image: MERU_IMAGES.wildlife,
    title: 'Arusha NP Safari Day',
    text: 'Add a game drive through Arusha National Park before your trek flamingos at Momella Lakes and wildlife at the mountain\'s base.',
  },
];

const GALLERY_IMAGES = [
  { src: MERU_IMAGES.hero, caption: 'Mount Meru' },
  { src: MERU_IMAGES.crater, caption: 'Meru Crater Rim' },
  { src: MERU_IMAGES.forest, caption: 'Montane Forest' },
  { src: MERU_IMAGES.summit, caption: 'Summit Views' },
  { src: MERU_IMAGES.huts, caption: 'Mountain Huts' },
  { src: MERU_IMAGES.wildlife, caption: 'Wildlife on the Slopes' },
];

const TREK_ROUTES = [
  {
    badge: 'popular',
    badgeLabel: 'Official route',
    title: 'Momella Route',
    duration: '3–4 days',
    difficulty: 'Moderate',
    success: 'High',
    text: 'The only trekking route on Mount Meru a single trail from Momella Gate through huts to Socialist Peak and back.',
    highlights: ['Momella Gate start', 'Miriakamba & Saddle huts', 'Crater rim traverse'],
  },
  {
    badge: 'recommended',
    badgeLabel: 'Day 1',
    title: 'Momella to Miriakamba',
    duration: '4–6 hrs',
    difficulty: 'Moderate',
    success: '—',
    text: 'Climb through montane forest with ranger escort wildlife sightings common and Miriakamba Hut marks the first overnight stop.',
    highlights: ['Cloud forest trail', 'Wildlife zone', 'Miriakamba Hut'],
  },
  {
    badge: 'classic',
    badgeLabel: 'Day 2',
    title: 'Miriakamba to Saddle Hut',
    duration: '3–5 hrs',
    difficulty: 'Strenuous',
    success: '—',
    text: 'A steep push to the crater rim and Saddle Hut dramatic views into the Meru caldera and Kilimanjaro on the horizon.',
    highlights: ['Crater rim views', 'Steep ascent', 'Saddle Hut'],
  },
  {
    badge: 'challenging',
    badgeLabel: 'Summit day',
    title: 'Socialist Peak Ascent',
    duration: '10–12 hrs',
    difficulty: 'Strenuous',
    success: '—',
    text: 'Pre-dawn start from Saddle Hut to Socialist Peak at 4,566 m summit at sunrise, then descend to Miriakamba or Momella.',
    highlights: ['Midnight start', 'Sunrise summit', 'Kili panorama'],
  },
];

const GETTING_THERE_ROUTES = [
  'Fly into Kilimanjaro International Airport (JRO) Arusha is approx. 1 hour away',
  'The trek starts at Momella Gate in Arusha National Park a 45-minute drive from Arusha town',
  'Most climbers stay one night in Arusha before the trek for briefing and gear check',
  'Pair with Kilimanjaro Meru is the ideal acclimatisation climb before a Kili summit attempt',
];

function Lightbox({ image, onClose }) {
  if (!image) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="meru-lightbox"
      role="dialog"
      aria-modal="true"
      aria-label="Image viewer"
      onClick={handleBackdropClick}
    >
      <button
        className="meru-lightbox__close"
        aria-label="Close image viewer"
        onClick={onClose}
      >
        ✕
      </button>
      <img
        className="meru-lightbox__img"
        src={image.src}
        alt={image.caption}
      />
      <span className="meru-lightbox__caption">{image.caption}</span>
    </div>
  );
}

function Meru() {
  const [lightboxImage, setLightboxImage] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="meru">
      <section className="meru-hero" aria-labelledby="meru-hero-heading">
        <div className="meru-hero__media" aria-hidden="true">
          <HeroSlideshow classPrefix="meru-hero" slides={MERU_HERO_SLIDES} fallback={IMAGE_FALLBACK} />
          <div className="meru-hero__overlay" />
        </div>
        <div className="page-container meru-hero__container">
          <div className="meru-hero__content">
            <nav className="meru-hero__breadcrumb" aria-label="Breadcrumb">
              <a href="/">Home</a>
              <span className="meru-hero__breadcrumb-sep" aria-hidden="true">›</span>
              <a href="#trekking">Trekking</a>
              <span className="meru-hero__breadcrumb-sep" aria-hidden="true">›</span>
              <span>Meru</span>
            </nav>
            <p className="meru-hero__eyebrow">Arusha National Park</p>
            <h1 id="meru-hero-heading">
              Mount
              <span>Meru</span>
            </h1>
            <p className="meru-hero__lead">
              Tanzania&apos;s second-highest peak a volcanic summit trek
              through cloud forest and crater rim, with Kilimanjaro on the horizon.
            </p>
            <div className="meru-hero__actions">
              <a className="meru-btn meru-btn--primary" href="#contact">
                Plan your Meru trek
              </a>
              <a className="meru-btn meru-btn--outline" href="#meru-gallery">
                View gallery
              </a>
            </div>
          </div>
        </div>
        <div className="meru-hero__stats">
          {HERO_STATS.map((stat) => (
            <div
              key={stat.label}
              className="meru-hero__stat"
              style={{ '--stat-delay': `${stat.delay}ms` }}
            >
              <span className="meru-hero__stat-value">{stat.value}</span>
              <span className="meru-hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </div>
      </section>

      <section
        id="meru-overview"
        className="meru-section meru-overview"
        aria-labelledby="overview-heading"
      >
        <div className="page-container">
          <div className="meru-overview__grid">
            <Reveal className="meru-overview__text">
              <p className="meru-section__eyebrow">About the mountain</p>
              <h2 id="overview-heading">Kilimanjaro&apos;s perfect warm-up</h2>
              <p>
                Mount Meru stands at the heart of Arusha National Park
                an active stratovolcano and Tanzania&apos;s second-highest
                mountain. The Momella Route is the only official trekking
                path, leading through wildlife-rich forest to the dramatic
                Meru crater rim and Socialist Peak.
              </p>
              <p>
                Most climbers choose Meru as an acclimatisation trek before
                Kilimanjaro four days on Meru prepares your body for altitude
                while offering crater views, forest trails, and a summit
                sunrise that rivals any in East Africa.
              </p>
              <ul className="meru-overview__details">
                <Reveal as="li" className="meru-overview__detail" delay={0}>
                  <span className="meru-overview__detail-label">Location</span>
                  <span className="meru-overview__detail-value">Arusha National Park</span>
                </Reveal>
                <Reveal as="li" className="meru-overview__detail" delay={80}>
                  <span className="meru-overview__detail-label">Summit</span>
                  <span className="meru-overview__detail-value">Socialist Peak, 4,566 m</span>
                </Reveal>
                <Reveal as="li" className="meru-overview__detail" delay={160}>
                  <span className="meru-overview__detail-label">Duration</span>
                  <span className="meru-overview__detail-value">3–4 days typical</span>
                </Reveal>
                <Reveal as="li" className="meru-overview__detail" delay={240}>
                  <span className="meru-overview__detail-label">Best for</span>
                  <span className="meru-overview__detail-value">Acclimatisation &amp; crater views</span>
                </Reveal>
              </ul>
            </Reveal>
            <Reveal className="meru-overview__image" variant="right" delay={200}>
              <SafeImage
                className="meru-overview__img"
                src={MERU_IMAGES.overview}
                alt="Silhouette of Mount Meru volcano at dusk"
              />
              <span className="meru-overview__image-accent" aria-hidden="true" />
            </Reveal>
          </div>
        </div>
      </section>

      <section
        id="meru-highlights"
        className="meru-section meru-wildlife"
        aria-labelledby="highlights-heading"
      >
        <div className="page-container">
          <Reveal className="meru-section__header">
            <p className="meru-section__eyebrow">Trek highlights</p>
            <h2 id="highlights-heading">Life on the mountain</h2>
            <p className="meru-section__intro">
              From cloud forest to crater rim six defining moments on
              the path to Socialist Peak.
            </p>
          </Reveal>
          <ul className="meru-wildlife__grid">
            {HIGHLIGHTS.map((item, index) => (
              <Reveal
                key={item.title}
                as="li"
                className="meru-wildlife__card"
                delay={index * 100}
                variant="scale"
              >
                <div className="meru-wildlife__icon-frame">
                  <span className="meru-wildlife__icon-ring" aria-hidden="true" />
                  <span
                    className="meru-wildlife__icon"
                    style={{ '--wildlife-face-position': item.facePosition }}
                  >
                    <img src={item.iconImage} alt={item.title} />
                  </span>
                </div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section
        id="meru-gallery"
        className="meru-section meru-gallery"
        aria-labelledby="gallery-heading"
      >
        <div className="page-container">
          <Reveal className="meru-section__header">
            <p className="meru-section__eyebrow">Photo gallery</p>
            <h2 id="gallery-heading">Scenes from Mount Meru</h2>
            <p className="meru-section__intro">
              From Momella forest trails to the summit ridge the
              mountain in every climate zone.
            </p>
          </Reveal>
          <div className="meru-gallery__grid">
            {GALLERY_IMAGES.map((img, index) => (
              <Reveal
                key={img.caption}
                className="meru-gallery__item"
                delay={index * 100}
                variant="scale"
                onClick={() => setLightboxImage(img)}
                role="button"
                tabIndex={0}
                aria-label={`View ${img.caption}`}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    setLightboxImage(img);
                  }
                }}
              >
                <SafeImage src={img.src} alt={img.caption} />
                <span className="meru-gallery__caption">{img.caption}</span>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section
        id="meru-routes"
        className="meru-section meru-routes"
        aria-labelledby="routes-heading"
      >
        <div className="page-container">
          <Reveal className="meru-section__header">
            <p className="meru-section__eyebrow">The Momella Route</p>
            <h2 id="routes-heading">Mount Meru trekking stages</h2>
            <p className="meru-section__intro">
              One official route from Momella Gate to Socialist Peak
              broken into stages with hut stops along the crater rim.
            </p>
          </Reveal>
          <ul className="meru-routes__grid">
            {TREK_ROUTES.map((route, index) => (
              <Reveal
                key={route.title}
                as="li"
                className="meru-routes__card"
                delay={index * 80}
              >
                <span
                  className={`meru-routes__badge meru-routes__badge--${route.badge}`}
                >
                  {route.badgeLabel}
                </span>
                <h3>{route.title}</h3>
                <dl className="meru-routes__meta">
                  <div>
                    <dt>Duration</dt>
                    <dd>{route.duration}</dd>
                  </div>
                  <div>
                    <dt>Difficulty</dt>
                    <dd>{route.difficulty}</dd>
                  </div>
                  <div>
                    <dt>Success rate</dt>
                    <dd>{route.success}</dd>
                  </div>
                </dl>
                <p>{route.text}</p>
                <ul className="meru-routes__highlights">
                  {route.highlights.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      {lightboxImage && (
        <Lightbox image={lightboxImage} onClose={() => setLightboxImage(null)} />
      )}

      <section
        id="meru-seasons"
        className="meru-section meru-seasons"
        aria-labelledby="seasons-heading"
      >
        <div className="page-container">
          <Reveal className="meru-section__header">
            <p className="meru-section__eyebrow">Plan your timing</p>
            <h2 id="seasons-heading">Best time to climb Mount Meru</h2>
            <p className="meru-section__intro">
              Dry seasons mirror Kilimanjaro clear skies and stable
              conditions for summit day and Kili views from the ridge.
            </p>
          </Reveal>
          <ul className="meru-seasons__grid">
            {SEASONS.map((season, index) => (
              <Reveal
                key={season.title}
                as="li"
                className="meru-seasons__card"
                delay={index * 120}
              >
                <span
                  className={`meru-seasons__card-badge meru-seasons__card-badge--${season.badge}`}
                >
                  {season.badge === 'peak'
                    ? '★ Peak Season'
                    : season.badge === 'green'
                      ? '🌿 Green Season'
                      : '◐ Shoulder Season'}
                </span>
                <h3>{season.title}</h3>
                <span className="meru-seasons__card-months">{season.months}</span>
                <p>{season.text}</p>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section
        id="meru-experiences"
        className="meru-section meru-experiences"
        aria-labelledby="experiences-heading"
      >
        <div className="page-container">
          <Reveal className="meru-section__header">
            <p className="meru-section__eyebrow">Trek combinations</p>
            <h2 id="experiences-heading">Ways to climb Mount Meru</h2>
            <p className="meru-section__intro">
              From a standalone crater trek to the classic Meru-then-Kili
              itinerary every option starts in Arusha National Park.
            </p>
          </Reveal>
          <ul className="meru-experiences__grid">
            {EXPERIENCES.map((exp, index) => (
              <Reveal
                key={exp.title}
                as="li"
                className="meru-experiences__card"
                delay={index * 120}
              >
                <div className="meru-experiences__card-image">
                  <SafeImage src={exp.image} alt={exp.title} />
                </div>
                <div className="meru-experiences__card-body">
                  <h3>{exp.title}</h3>
                  <p>{exp.text}</p>
                </div>
              </Reveal>
            ))}
          </ul>
        </div>
      </section>

      <section
        id="meru-getting-there"
        className="meru-section meru-getting-there"
        aria-labelledby="getting-there-heading"
      >
        <div className="page-container">
          <div className="meru-getting-there__inner">
            <Reveal className="meru-getting-there__copy">
              <p className="meru-section__eyebrow">Getting there</p>
              <h2 id="getting-there-heading">How to reach Mount Meru</h2>
              <p>
                Mount Meru lies inside Arusha National Park, a short
                drive from Arusha town. Treks begin at Momella Gate with
                a mandatory armed ranger escort through the wildlife zone.
              </p>
              <ul className="meru-getting-there__routes">
                {GETTING_THERE_ROUTES.map((route) => (
                  <li key={route}>{route}</li>
                ))}
              </ul>
            </Reveal>
            <Reveal className="meru-getting-there__map" variant="right" delay={200}>
              <iframe
                title="Mount Meru location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d255168.089654321!2d36.75!3d-3.25!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1837148a8b8b8b8b%3A0x1234567890abcdef!2sMount%20Meru!5e0!3m2!1sen!2stz!4v1700000000000!5m2!1sen!2stz"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </Reveal>
          </div>
        </div>
      </section>

      <section className="meru-cta" aria-labelledby="meru-cta-heading">
        <div className="page-container">
          <Reveal variant="scale" delay={0}>
            <div className="meru-cta__inner">
              <h2 id="meru-cta-heading">
                Ready to climb Tanzania&apos;s second peak?
              </h2>
              <p>
                Tell us your travel dates and fitness level we&apos;ll design a
                tailor-made Meru trek with licensed guides, hut stays, and
                optional Kilimanjaro connections.
              </p>
              <a
                className="meru-btn meru-btn--primary meru-btn--lg"
                href="#contact"
              >
                Get a free Meru quote
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}

export default Meru;
